module.exports = __webpack_public_path__ + "components/panel/static/affiliate_snow-holidays-f004434bc8b3634026629655db71f076.jpg";